// import app from "gridsome/lib/app";
import { Commons } from '../../utils/commons'
import { AppData } from './appData'

class Formatter {
  static parseExternalAppInfo(raw) {
    if (!raw) return null
    const appData = new AppData()
    appData.setContent('appInfo').setMetaData({
      ...raw,
      sizes: raw.sizes,
      registrationFee: raw.registrationFee || 0,
      customerPaymentFeeMobileMoney: raw.customerPaymentFeeMobileMoney || 0,
      customerPaymentFeeCardQos: raw.customerPaymentFeeCardQos || 0,
      customerPaymentFeeCardCinetpay: raw.customerPaymentFeeCardCinetpay || 0,
      customerPaymentFeeCardStripe: raw.customerPaymentFeeCardStripe || 0,
      merchandPaymentFeeMobileMoney: raw.merchandPaymentFeeMobileMoney || 0,
      merchandPaymentFeeCardQos: raw.merchandPaymentFeeCardQos || 0,
      merchandPaymentFeeCardCinetpay: raw.merchandPaymentFeeCardCinetpay || 0,
      merchandPaymentFeeCardStripe: raw.merchandPaymentFeeCardStripe || 0,
      plansPricesMonth: raw.plansPricesMonth || {
        basic: 0,
        essenciel: 0,
        ekilite: 0,
        ekipro: 0,
      },
      cardPaymentAvailablilityDelayUnit:
        raw.cardPaymentAvailablilityDelayUnit || 0,
      cardPaymentAvailablilityDelay: raw.cardPaymentAvailablilityDelay || 0,
      withdrawalFeeMobileMoney: raw.withdrawalFeeMobileMoney || 0,
      withdrawalFeeBank: raw.withdrawalFeeBank || 0,
      merchandPaymentFeeMobileMoneyPro:
        raw.merchandPaymentFeeMobileMoneyPro || 0,
      merchandPaymentFeeCardQosPro: raw.merchandPaymentFeeCardQosPro || 0,
      merchandPaymentFeeCardCinetpayPro:
        raw.merchandPaymentFeeCardCinetpayPro || 0,
      merchandPaymentFeeCardStripePro: raw.merchandPaymentFeeCardStripePro || 0,
      cardPaymentAvailablilityDelayUnitPro:
        raw.cardPaymentAvailablilityDelayUnitPro || 0,
      cardPaymentAvailablilityDelayPro:
        raw.cardPaymentAvailablilityDelayPro || 0,
      withdrawalFeeMobileMoneyPro: raw.withdrawalFeeMobileMoneyPro || 0,
      withdrawalFeeBankPro: raw.withdrawalFeeBankPro || 0,
      ekidiscountProFee: raw.ekidiscountProFee || 0,
      topProductPromotionCostPerDay: raw.topProductPromotionCostPerDay || 0,
      topProductPromotionMinDuration: raw.topProductPromotionMinDuration || 0,

      customerPaymentFeeCard: undefined,
      merchandPaymentFeeCard: undefined,

      whatsappUrl: raw.whatsappUrl || '',
      facebookUrl: raw.facebookUrl || '',
      snapchatUrl: raw.snapchatUrl || '',
      linkedinUrl: raw.linkedinUrl || '',
      instagramUrl: raw.instagramUrl || '',
      tiktokUrl: raw.tiktokUrl || '',
      email: raw.email || '',
      invoicesNotificationMail: raw.invoicesNotificationMail || '',
    })
    return appData
  }

  static parseExternalSubscription(raw) {
    if (!raw) return null
    const appData = new AppData()
    const isActive = raw.status == '' || raw.status == 'active'
    appData.setContent('subscription').setMetaData({
      ...raw,
      isActive: isActive,
      status: raw.status || isActive ? 'active' : 'inactif',
      subscriberId: raw.subscriberId,
      endDate: raw.endDate || 0,
      startDate: raw.startDate || 0,
    })
    return appData
  }

  static parseExternalWalletInfo(raw) {
    console.log(raw)
    if (!raw) return null
    const appData = new AppData()
    appData.setContent('walletInfo').setMetaData({
      balance: raw?.availableBalance?.body?.data?.balance || '0',
      pendingBalance: raw?.pendingBalance?.body?.data?.balance || '0',
    })
    return appData
  }

  static parseStoresBalances(raw, stores) {
    console.log(raw)
    if (!raw) return null
    const appData = new AppData()
    const storesBalances = {}
    let totalBalance = 0
    let totalPendingBalance = 0
    stores.forEach(store => {
      const storeBalance = {
        balance:
          raw[`availableBalance_${store.id}`]?.body?.data?.balance || '0',
        pendingBalance:
          raw[`pendingBalance_${store.id}`]?.body?.data?.balance || '0',
      }
      storesBalances[store.id] = storeBalance
      totalBalance += parseInt(storeBalance.balance)
      totalPendingBalance += parseInt(storeBalance.pendingBalance)
    })
    appData.setContent('storesBalances').setMetaData({
      totalBalance,
      totalPendingBalance,
      storesBalances,
    })
    return appData
  }

  static parseExternalStore(raw) {
    if (!raw) return null
    const appData = new AppData()
    appData.setContent('storeData').setMetaData({
      ...raw,
      id: raw.id,
      cardPaymentEnabled: raw.cardPaymentEnabled,
      customDomainName: raw.customDomainName,
      deliveryMethod: raw.deliveryMethod,
      facebookLink: raw.facebookLink,
      instagramLink: raw.instagramLink,
      linkedinLink: raw.linkedinLink,
      logo: raw.logo,
      mainColor: raw.mainColor,
      mobileMoneyPaymentEnabled: raw.mobileMoneyPaymentEnabled,
      notifyCustomerOnOrderDelivered: raw.notifyCustomerOnOrderDelivered,
      notifyCustomerOnPaymentDone: raw.notifyCustomerOnPaymentDone,
      notifyStoreOnBalanceUpdated: raw.notifyStoreOnBalanceUpdated,
      notifyStoreOnOrderDelivered: raw.notifyStoreOnOrderDelivered,
      notifyStoreOnPaymentDone: raw.notifyStoreOnPaymentDone,
      publicStoreId: raw.publicStoreId,
      snapchatLink: raw.snapchatLink,
      storeName: raw.storeName,
      twitterLink: raw.twitterLink,
      useCustomDomain: raw.useCustomDomain,
      userId: raw.userId,
      whatsappChannel: raw.whatsappChannel,
      whatsappNumberHelp: raw.whatsappNumberHelp,
    })
    return appData
  }

  static parseExternalStores(raw) {
    if (!raw) return null
    if (!Array.isArray(raw?.data)) return null
    const appData = new AppData()
    appData.setContent('stores').setMetaData({
      page: raw.page,
      total: raw.total,
      stores: raw?.data
        .map(store => {
          return {
            ...store,
            id: store.id,
            createdAt: store.createdAt || 0,
            cardPaymentEnabled: store.cardPaymentEnabled,
            customDomainName: store.customDomainName,
            deliveryMethod: store.deliveryMethod,
            facebookLink: store.facebookLink,
            instagramLink: store.instagramLink,
            linkedinLink: store.linkedinLink,
            logo: store.logo,
            mainColor: store.mainColor,
            mobileMoneyPaymentEnabled: store.mobileMoneyPaymentEnabled,
            notifyCustomerOnOrderDelivered:
              store.notifyCustomerOnOrderDelivered,
            notifyCustomerOnPaymentDone: store.notifyCustomerOnPaymentDone,
            notifyStoreOnBalanceUpdated: store.notifyStoreOnBalanceUpdated,
            notifyStoreOnOrderDelivered: store.notifyStoreOnOrderDelivered,
            notifyStoreOnPaymentDone: store.notifyStoreOnPaymentDone,
            publicStoreId: store.publicStoreId,
            snapchatLink: store.snapchatLink,
            storeName: store.storeName,
            twitterLink: store.twitterLink,
            useCustomDomain: store.useCustomDomain,
            userId: store.userId,
            whatsappChannel: store.whatsappChannel,
            whatsappNumberHelp: store.whatsappNumberHelp,
          }
        })
        // .reverse()
        .sort((store1, store2) => store2.createdAt - store1.createdAt),
    })
    return appData
  }

  static parseExternalCategories(rawCategories) {
    if (!rawCategories) return null
    if (!Array.isArray(rawCategories)) return null
    const appData = new AppData()
    appData.setContent('categories').setMetaData({
      categories: rawCategories.map(category => {
        const groups = {}
        const subcategories = category.subcategories || []
        subcategories.forEach(subCategory => {
          if (!groups[subCategory.groupName]) {
            groups[subCategory.groupName] = {
              name: subCategory.name,
              subcategories: [],
            }
          }
          groups[subCategory.groupName].subcategories.push(subCategory)
        })
        return {
          ...category,
          id: category.id,
          name: category.name,
          imageUrl:
            (category.imageUrl.startsWith('/images')
              ? `https://ekidiscount.com`
              : '') + category.imageUrl,
          // icon: category.icon,
          groupedSubcategories: Object.values(groups),
        }
      }),
    })
    return appData
  }

  static parseExternalPubs(raw) {
    if (!raw) return null
    if (!Array.isArray(raw)) return null
    const appData = new AppData()
    appData.setContent('pubs').setMetaData({
      pubs: raw.map(pub => {
        return {
          id: pub.id,
          action: pub.action,
          animate: pub.animate,
          description: pub.description,
          isMain: pub.isMain,
          link: pub.link,
          picture: pub.picture.map(pic => {
            return (
              (pic.startsWith('/images') ? `https://ekidiscount.com` : '') +
              pic
            )
          }),
          service: pub.service,
          title: pub.title,
        }
      }),
    })
    return appData
  }

  static parseExternalProducts(rawProducts) {
    if (!rawProducts) return null
    if (!Array.isArray(rawProducts)) return null
    const appData = new AppData()
    appData.setContent('products').setMetaData({
      products: rawProducts
        .map(Formatter.parseExternalProductDetails)
        .reverse(),
    })
    return appData
  }

  static parseExternalDeals(rawDeals) {
    if (!rawDeals) return null
    if (!Array.isArray(rawDeals)) return null
    const appData = new AppData()
    appData.setContent('deals').setMetaData({
      deals: rawDeals.map(deal => {
        return {
          ...Formatter.parseExternalProductDetails(deal.productData),
          ...deal,
          id: deal.id,
          discount: deal.discount || 0,
          discountedPrice:
            deal.productData.price -
            (deal.productData.price * deal.discount) / 100,
          endDate: deal.endDate,
          inPercent: deal.inPercent,
          isActive: deal.isActive,
          productData: deal.productData,
          productId: deal.productId,
          startDate: deal.startDate,
          storeId: deal.storeId,
        }
      }),
    })
    return appData
  }

  static parseExternalProductDetails(product) {
    return {
      // ...product,
      id: product.id,
      name: product.title,
      price: product.price,
      storeId: product.storeId,
      storeName: product.storeName,
      description: product.description,
      category: product.category,
      categoryId: product.categoryId,
      subcategory: product.subcategory,
      subcategoryId: product.subcategoryId,
      image: product.principalImageUrl,
      brand: product.brand,
      color: product.color,
      material: product.material,
      condition: product.condition,
      weight: product.weight,
      size: product.size,
      weightUnit: product.weightUnit,
      quantity: product.quantity,
      images: product.additionalImageUrl,
      isPublished: product.isPublished,

      downloadLink: product.downloadLink || '',
      isDigitalProduct: product.isDigitalProduct || false,
      rawProduct: product,
    }
  }

  static parseExternalOrders(raw) {
    if (!raw?.data) return null
    if (!Array.isArray(raw?.data)) return null
    const appData = new AppData()
    appData.setContent('orders').setMetaData({
      page: raw.page,
      total: raw.total,
      orders: raw.data
        .map(order => {
          return {
            ...order,
            id: order.id,
            publicId: order.publicId,
            shippingMethod: order.shippingMethod,
            status: order.status,
            orderDate: order.orderDate,
            customerName: order.customerName,
            paymentMethod: order.paymentMethod,
            totalPrice: order.totalPrice,
            products: order.products,
          }
        })
        .reverse()
        .sort((o1, o2) => o2.orderDate - o1.orderDate),
    })
    return appData
  }

  static parseWithdrawalAccounts(rawAccounts) {
    if (!rawAccounts) return null
    if (!Array.isArray(rawAccounts)) return null
    const momoAccounts = []
    const bankAccounts = []
    rawAccounts.forEach(account => {
      const formatted = {
        image: `https://ui-avatars.com/api/?background=111429&color=fff&name=${
          account.fullName
        }&bold=true&font-size=0.55`,
        id: account.id,
        email: account.email,
        ownerId: account.ownerId,
        metadata: {
          ...account.metadata,
          type: account.metadata.type,
        },
        updateDate: account.updateDate,
        lastName: account.lastName,
        fullName: account.fullName,
        firstName: account.firstName,
        creationDate: account.creationDate,
        phoneNumber: account.phoneNumber,
        countryCode: account.countryCode,
        businessName: account.businessName,
      }
      if (account.metadata.type == 'bank') bankAccounts.push(formatted)
      else momoAccounts.push(formatted)
    })
    const appDataBank = new AppData()
    appDataBank.setContent('withdrawalAccountsBank').setMetaData({
      accounts: bankAccounts.sort(
        (a1, a2) => a2.creationDate - a1.creationDate,
      ),
    })
    const appDataMomo = new AppData()
    appDataMomo.setContent('withdrawalAccountsMomo').setMetaData({
      accounts: momoAccounts.sort(
        (a1, a2) => a2.creationDate - a1.creationDate,
      ),
    })
    return [appDataBank, appDataMomo]
  }

  static parseWithdrawals(raw) {
    if (!raw) return null
    if (!Array.isArray(raw.data)) return null
    const withdrawals = raw.data.map(withdrawal => {
      return {
        id: withdrawal.id,
        amount: withdrawal.amount,
        status: withdrawal.status,
        statusMessage: withdrawal.statusMessage,
        storeId: withdrawal.storeId,
        type: withdrawal.type,
        withdrawalAccount: withdrawal.withdrawalAccount,
        date: withdrawal.date,
        lastUpdateAt: withdrawal.lastUpdateAt,
        manualOperationId: withdrawal.manualOperationId,
        amountToCollect: withdrawal.amountToCollect,
        amountToDeposit: withdrawal.amountToDeposit,
        srcServiceFee: withdrawal.srcServiceFee,
        dstServiceFee: withdrawal.dstServiceFee,
        srcProcessorFee: withdrawal.srcProcessorFee,
        dstProcessorFee: withdrawal.dstProcessorFee,
        earning: withdrawal.earning,
      }
    })
    const appData = new AppData()
    appData.setContent('withdrawals').setMetaData({
      page: raw.page,
      total: raw.total,
      withdrawals: withdrawals.sort((w1, w2) => w2.date - w1.date),
    })
    return appData
  }

  static parseExternalCustomers(rawRiders) {
    if (!rawRiders) return null
    if (!Array.isArray(rawRiders)) return null
    const appData = new AppData()
    appData.setContent('customers').setMetaData({
      customers: rawRiders
        .map(customer => {
          return {
            ...customer,
            id: customer.id,
            image: customer.image,
            name: customer.name,
            email: customer.email,
            lastOrder: customer.lastOrder,
            totalOrdersCount: customer.totalOrdersCount,
            totalOrdersAmount: customer.totalOrdersAmount,
          }
        })
        .sort((c1, c2) => c2.lastOrder - c1.lastOrder),
    })
    return appData
  }

  static parseTeammates(raw) {
    if (!raw) return null
    if (!Array.isArray(raw)) return null
    const appData = new AppData()
    appData.setContent('teammates').setMetaData({
      teammates: raw
        .map(user => {
          return {
            ...user,
            id: user.id,
            image: `https://ui-avatars.com/api/?background=111429&color=fff&name=${
              user.email
            }&bold=true&font-size=0.55`,
            firstName: user.firstName,
            lastName: user.lastName,
            createdAt: user.createdAt,
            updatedAt: user.updatedAt,
            email: user.email,
            phoneNumber: user.phoneNumber,
            countryCode: user.countryCode,
            metadata: {
              ...user.metadata,
              permissions: user.metadata.permissions || [],
            },
          }
        })
        .reverse(),
    })
    return appData
  }

  static parseExternalRiders(rawRiders) {
    if (!rawRiders) return null
    if (!Array.isArray(rawRiders)) return null
    const appData = new AppData()
    appData.setContent('riders').setMetaData({
      riders: rawRiders
        .map(rider => {
          return {
            ...rider,
            id: rider.id,
            image: `https://ui-avatars.com/api/?background=111429&color=fff&name=${
              rider.email
            }&bold=true&font-size=0.55`,
            email: rider.email,
            createdAt: rider.createdAt,
            firstName: rider.firstName,
            lastName: rider.lastName,
            pendingDelivery: rider.pendingDelivery,
            position: rider.position,
            storeId: rider.storeId,
            totalDelivered: rider.totalDelivered,
          }
        })
        .sort((c1, c2) => c2.createdAt - c1.createdAt),
    })
    return appData
  }

  static parseChargebacks(raw) {
    if (!raw) return null
    if (!Array.isArray(raw?.data)) return null
    const appData = new AppData()
    appData.setContent('payments').setMetaData({
      page: raw.page,
      total: raw.total,
      chargebacks: raw?.data
        .map(chargeback => {
          return {
            ...chargeback,
            id: chargeback.id,
            amount: chargeback.amount,
            appliedAt: chargeback.appliedAt,
            createdAt: chargeback.createdAt,
            currency: chargeback.currency,
            isApplied: chargeback.isApplied,
            transactionId: chargeback.transactionId,
            message: chargeback.message,
            productName: chargeback.transactionData.productName,
            description: chargeback.transactionData.description,
            tags: chargeback.transactionData.tags,
            colors: chargeback.transactionData.colors,
            price: chargeback.transactionData.price,
            quantity: chargeback.transactionData.quantity,
            sku: chargeback.transactionData.sku,
            rating: chargeback.transactionData.rating,
            reviews: chargeback.transactionData.reviews,
            image: chargeback.transactionData.image,
            date: chargeback.transactionData.date,
            customerName: chargeback.transactionData.customerName,
            status: chargeback.transactionData.status,
            statusMessage: chargeback.transactionData.statusMessage,
          }
        })
        .reverse()
        .sort((c1, c2) => c2.createdAt - c1.createdAt),
    })
    return appData
  }

  static parseExternalPayments(raw) {
    if (!raw) return null
    if (!Array.isArray(raw?.data || raw?.results)) return null
    const appData = new AppData()
    appData.setContent('payments').setMetaData({
      page: raw.page,
      total: raw.total,
      payments: (raw?.data || raw?.results)
        .map(payment => {
          return {
            ...payment,
            id: payment.id,
            productName: payment.productName,
            description: payment.description,
            tags: payment.tags,
            colors: payment.colors,
            price: payment.price,
            quantity: payment.quantity,
            sku: payment.sku,
            rating: payment.rating,
            reviews: payment.reviews,
            image: payment.image,
            date: payment.date,
            customerName: payment.customerName,
            status: payment.status,
            statusMessage: payment.statusMessage,
          }
        })
        .reverse()
        .sort((c1, c2) => c2.date - c1.date),
    })
    return appData
  }

  static parseStoresStats(raw, stores) {
    console.log(raw)
    if (!raw) return null
    const appData = new AppData()
    const storesStats = {}
    stores.forEach(store => {
      const storeStats = {
        customerStats: raw[`customerStats_${store.id}`]?.body?.data || {},
        orderStats: raw[`orderStats_${store.id}`]?.body?.data || {},
        paymentFailedStats:
          raw[`paymentFailedStats_${store.id}`]?.body?.data || {},
        paymentDoneStats: raw[`paymentDoneStats_${store.id}`]?.body?.data || {},
      }
      storesStats[store.id] = storeStats
    })
    appData.setContent('storesStats').setMetaData({
      storesStats,
    })
    return appData
  }

  static parseStatsResponse(raw) {
    if (!raw) return null
    const appData = new AppData()
    appData.setContent('stats').setMetaData({
      balanceAvailable: raw.balanceAvailable.body?.data,
      balancePending: raw.balancePending.body?.data,
      customerStats: raw.customerStats.body?.data,
      customerStatsWeek: raw.customerStatsWeek.body?.data?.reverse(),
      customerStatsMonth: raw.customerStatsMonth.body?.data?.reverse(),
      customerStatsYear: raw.customerStatsYear.body?.data?.reverse(),
      orderStats: raw.orderStats.body?.data,
      orderStatsWeek: raw.orderStatsWeek.body?.data?.reverse(),
      orderStatsMonth: raw.orderStatsMonth.body?.data?.reverse(),
      orderStatsYear: raw.orderStatsYear.body?.data?.reverse(),
      paymentInitiatedStats: raw.paymentInitiatedStats.body?.data,
      paymentFailedStats: raw.paymentFailedStats.body?.data,
      paymentDoneStats: raw.paymentDoneStats.body?.data,
      paymentStats: raw.paymentDoneStats.body?.data,
      paymentStatsWeek: raw.paymentStatsWeek.body?.data?.reverse(),
      paymentStatsMonth: raw.paymentStatsMonth.body?.data?.reverse(),
      paymentStatsYear: raw.paymentStatsYear.body?.data?.reverse(),
    })
    return appData
  }

  static parseExternalKycData(raw, userId) {
    const appData = new AppData()
    const isFilled = !!(
      raw?.validationStatus &&
      (raw?.validationStatus !== 'notFilled' ||
        raw?.validationStatus == 'filled')
    )
    const isValidated = raw?.validationStatus == 'validated'
    const isPending = raw?.validationStatus == 'pending'
    const isRejected = raw?.validationStatus == 'rejected'
    appData.setContent('kycData').setMetaData({
      ...(raw || {}),
      data: raw?.data || {},
      rejectionReason: raw.rejectionReason || '',
      url: 'https://kyc.marketplace.ecoxurf.com?id=' + userId,
      isFilled,
      isValidated,
      isPending,
      isRejected,
    })
    return appData
  }

  static buildAppDataEntity(rawData) {
    if (!rawData) return null
    const appData = new AppData()
    appData.setContent(rawData.content).setMetaData(rawData.metaData)
    return appData
  }
}

function formatIsLockedData(raw = {}) {
  const metaDataKeys = ['isLocked']
  return formatMetaData(raw, metaDataKeys)
}

function formatMetaData(source, keys) {
  const metaData = {}
  keys.forEach(key => {
    metaData[key] = source[key]
  })
  return metaData
}

function formatPubsMetaData(rawPubs = []) {
  if (!Array.isArray(rawPubs)) return { pubs: [] }
  return {
    pubs: rawPubs.map(pub => {
      return {
        title: pub.title,
        description: pub.description,
        pictureUrl: pub.pictureUrl,
        actionTitle: pub.actionTitle,
        action: pub.action,
        isCouponsPub: pub.isCouponsPub,
        date: pub.date,
      }
    }),
  }
}

function formatCouponsMetaData(rawCoupons = []) {
  if (!Array.isArray(rawCoupons)) return { coupons: [] }
  return {
    coupons: rawCoupons.map(coupon => {
      return {
        pictureUrl: coupon.pictureUrl,
        isVip: coupon.isVip,
        code: coupon.code || '',
        isValidated: coupon.isValidated || false,
        bookmaker: coupon.bookmaker || '',
      }
    }),
  }
}

// function formatTopMatchesMetaData(rawTopMatches = []) {
//   if (!Array.isArray(rawTopMatches)) return { pubs: [] };
//   return {
//     topMatches: rawTopMatches.map((match, i) => {
//       let statusDisplay = "Non démaré";
//       if (match.matchStatus == "finished") statusDisplay = "Terminé";
//       if (match.matchStatus == "starting") statusDisplay = "En cours";
//       if (match.matchStatus == "live") statusDisplay = "En cours";
//       return {
//         id: i,
//         startTimestamp: match.startTimestamp,
//         day: match.day,
//         month: match.month,
//         year: match.year,
//         liveDurationMin: match.liveDurationMin,
//         dateDisplay: Commons.timestampToDate(
//           match.startTimestamp,
//           "DD MMM YYYY HH:mm"
//         ),
//         statusDisplay,
//         matchStatus: match.matchStatus,
//         startHour: match.startHour,
//         startMin: match.startMin,
//         matchId: match.matchId,
//         competitionName: match.competitionName,
//         matchPageUrl: match.matchPageUrl,
//         team1Name: match.team1Name,
//         team2Name: match.team2Name,
//         team1Score: match.team1Score,
//         team2Score: match.team2Score,
//         team1Picture: match.team1Picture,
//         team2Picture: match.team2Picture,
//       };
//     }),
//   };
// }

function formatTopMatchesMetaData(rawTopMatches = []) {
  if (!Array.isArray(rawTopMatches)) return { topMatches: [] }
  console.log(rawTopMatches.length)
  rawTopMatches = rawTopMatches.splice(0, 200)
  return {
    isSorted: true,
    updatedAt: Date.now(),
    topMatches: rawTopMatches
      .map((match, i) => {
        const matchStatus = match.isLive ? 'live' : 'notStarted'
        let statusDisplay = 'Non démaré'
        if (matchStatus == 'finished') statusDisplay = 'Terminé'
        if (matchStatus == 'starting') statusDisplay = 'En cours'
        if (matchStatus == 'live') statusDisplay = 'En cours'
        const date = new Date(match.date_start)
        let durationMin = (Date.now() - date.getTime()) / 1000 / 60
        durationMin = parseInt(durationMin)
        let usedMarkey = {}
        if (match.markets)
          usedMarkey = {
            win1: match.markets.win1,
            win2: match.markets.win2,
            winX: match.markets.winX,
            win12: match.markets.win12,
            win1X: match.markets.win1X,
            winX2: match.markets.winX2,
          }

        return {
          id: i,
          isLive: match.isLive,
          startTimestamp: date.getTime(),
          day: date.getDay(),
          month: date.getMonth(),
          year: date.getFullYear(),
          liveDurationMin: durationMin,
          dateDisplay: Commons.timestampToDate(
            date.getTime(),
            'DD MMM YYYY HH:mm',
          ),
          statusDisplay,
          matchStatus: matchStatus,
          startHour: date.getHours(),
          startMin: date.getMinutes(),
          matchId: match.id,
          competitionName: match.title,
          matchPageUrl: '',
          matchName: getMatchName(match.team1, match.team2),
          team1Name: match.team1,
          team2Name: match.team2,
          team1Score: match.score1,
          team2Score: match.score2,
          team1Picture: '',
          team2Picture: '',
          team1Picture: '/images/football.svg',
          team2Picture: '/images/football.svg',
          // ...match,
          markets: usedMarkey,
        }
      })
      .sort((match1, match2) => {
        if (match1.startTimestamp > match2.startTimestamp) return 1
        if (match1.startTimestamp < match2.startTimestamp) return -1
        return 0
      }),
  }
}

function formatMatchFiltersMetaData(upcoming = [], live = []) {
  if (!Array.isArray(upcoming) || !Array.isArray(live)) return { filters: [] }
  const filtersIds = {}
  return {
    updatedAt: Date.now(),
    filters: [...live, ...upcoming]
      .map((filter, i) => {
        if (filtersIds[filter.league_id]) return null
        if (/[Государственный'||"{?;]/i.test(filter.league || filter.title))
          return null
        filtersIds[filter.league_id] = true
        return {
          id: filter.league_id,
          name: filter.league || filter.title,
          title: filter.title,
          ...filter,
        }
      })
      .filter(filter => !!filter),
  }
}

function getMatchName(team1, team2) {
  let max = 15
  let team1Short = team1.slice(0, max)
  let team2Short = team2.slice(0, max)
  if (team1.length > max) team1Short = team1.slice(0, max - 3) + '...'
  if (team2.length > max) team2Short = team2.slice(0, max - 3) + '...'
  return team1Short + ' VS ' + team2Short
}

export { Formatter }
